// frontend/src/samkalp-admin/tabs/shared.js
//
// Small shared UI helpers, duplicated from frontend/src/pages/AskOSAdmin.js
// (StatusBadge, EmptyRow, useAlert, UInput are not exported there, so direct
// import isn't possible — see the Samkalp multi-centre plan for why
// duplication, not extraction, is the confirmed-safe path here).
import React, { useState } from 'react';
import { Badge, Form } from 'react-bootstrap';
import { CheckCircle2, XCircle } from 'lucide-react';

export const StatusBadge = ({ status }) => (
    <Badge
        className={status === 'active' ? 'badge-soft-success' : 'bg-secondary bg-opacity-10 text-secondary'}
        style={{ fontSize: '0.7rem' }}
    >
        {status === 'active'
            ? <CheckCircle2 size={10} className="me-1" />
            : <XCircle size={10} className="me-1" />
        }
        {status}
    </Badge>
);

export const EmptyRow = ({ cols, icon: Icon, message }) => (
    <tr>
        <td colSpan={cols} className="text-center py-5 text-muted">
            <Icon size={28} className="mb-2 opacity-50 d-block mx-auto" />
            <span className="small">{message}</span>
        </td>
    </tr>
);

export const useAlert = () => {
    const [alert, setAlert] = useState(null);
    const showAlert = (msg, variant = 'success') => {
        setAlert({ msg, variant });
        setTimeout(() => setAlert(null), 3500);
    };
    return [alert, showAlert];
};

export const UInput = ({ label, ...props }) => (
    <Form.Group className="mb-3">
        <Form.Label className="x-small fw-bold text-muted text-uppercase">{label}</Form.Label>
        <Form.Control className="border-0 border-bottom rounded-0 px-0 shadow-none bg-transparent" {...props} />
    </Form.Group>
);
